import React, { useState } from 'react'
import * as bie from "react-bootstrap";
import { Field, Form, FormikProvider, useFormik } from 'formik';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


export default function ParliamentwiseSchemeDetails({ rusaPhase }) {
    const AsmparlFormik = useFormik({
        initialValues: {
            Asm_Parl: "",
            apname: "",
            clgname: "",


        },
        // validationSchema: validationSchema,
        onSubmit: (values) => {
            GetAssemblyList(values);


        },
    });

    const [assemblyList, setAssemblyList] = useState([]);
    function GetAssemblyList(selectedvalue) {
        if (!selectedvalue || selectedvalue.trim() === "") {
            console.log("Skipping API call — invalid selectedvalue :", selectedvalue);
            return;
        }
        let url = `${config.url.API_URL}getAsmParlData?Asm_Parl=${selectedvalue}&rusa_phase=${rusaPhase}`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setAssemblyList(res?.data?.data);


            }
            else {
                setAssemblyList([]);


            }
        });
    }



    const [financaData, setFinancaData] = useState([]);
    const [erromsg, setErrormsg] = useState('');
    function GetFinanceList(assmbletype, constname) {
        if (!assmbletype || assmbletype.trim() === "") {
            console.log("❌ Skipping API call — invalid assmbletype:", assmbletype);
            return;
        }

        // Validate constituency name
        if (!constname || constname.trim() === "") {
            console.log("❌ Skipping API call — invalid constname:", constname);
            return;
        }

        let url = `${config.url.API_URL}getAssemblyParlwiseDetails?Asm_Parl=${assmbletype}&A_Pname=${constname}&rusa_phase=${rusaPhase}`;
        console.log(url, "url")
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setFinancaData(res?.data?.data);
                setErrormsg(true);


            }
            else {
                setFinancaData([]);
                setErrormsg(false);


            }
        });
    }



    const data = Array?.isArray(financaData) ? financaData : [];


    const dataset = data?.map((item) => ({
        name: item?.institution_name || "Institute",

        stateApproved: Number(item?.state_share_approved || 0),
        centralApproved: Number(item?.central_share_approved || 0),

        totalApproved:
            Number(item?.state_share_approved || 0) +
            Number(item?.central_share_approved || 0),

        stateUtilised: Number(item?.state_share_utilised || 0),
        centralUtilised: Number(item?.central_share_utilised || 0),

        totalUtilised:
            Number(item?.state_share_utilised || 0) +
            Number(item?.central_share_utilised || 0),

        remarks: item?.remarks || "",
    }));
    const categories = dataset.map(d => d.name);

    const stateApproved = dataset?.map(d => d?.stateApproved);
    const centralApproved = dataset?.map(d => d?.centralApproved);
    const stateUtilised = dataset?.map(d => d?.stateUtilised);
    const centralUtilised = dataset?.map(d => d?.centralUtilised);
    const totalApproved = dataset?.map(d => d?.totalApproved);
    const options = {
        chart: {
            type: "column",
            height: 360
        },

        title: {
            text: ""
        },

        xAxis: {
            categories,
            labels: {
                rotation: 0,
                // rotation: -20,
                useHTML: true,
                formatter() {

                    return this.value.split(", ").join("<br/>"); // NOSONAR - Highcharts formatter requires 'this' context

                },
                style: {
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    textAlign: "center"
                }
            }
        },

        yAxis: {
            title: { text: null },

            labels: {
                formatter: function () {
                    /* eslint-disable react/no-this-in-sfc */
                    if (this.isLast) { // NOSONAR - Highcharts formatter requires 'this' context
                        return "";
                    }

                    return "₹" + this.value.toLocaleString("en-IN"); // NOSONAR - Highcharts formatter requires 'this' context
                    /* eslint-enable react/no-this-in-sfc */

                }
            }
        }
        ,

        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function () {
                /* eslint-disable react/no-this-in-sfc */

                const index = this.points[0].point.index; // NOSONAR - Highcharts formatter requires 'this' context

                const name = this.points[0].series.xAxis.categories[index]; // NOSONAR - Highcharts formatter requires 'this' context

                let html = `<b style="font-size:13px">${name}</b><br/>`;


                this.points.forEach(p => { // NOSONAR - Highcharts formatter requires 'this' context
                    html += `
                <span style="color:${p.color}">●</span>
                ${p.series.name}: 
                <b>₹${p.y.toLocaleString("en-IN")}</b><br/>
            `;
                });


                return html;
                /* eslint-enable react/no-this-in-sfc */

            }
        }
        ,

        legend: {
            align: "center",
            verticalAlign: "bottom"
        },

        plotOptions: {
            column: {
                dataLabels: {
                    enabled: false   // ✅ removes all values above bars
                }
            }
        },

        series: [
            {
                name: "State Approved",
                data: stateApproved,
                color: "#6FA672"
            },
            {
                name: "Central Approved",
                data: centralApproved,
                color: "#8FD3C8"

            },
            {
                name: "State Utilised",
                data: stateUtilised,
                color: "#93B5FF"
            },
            {
                name: "Central Utilised",
                data: centralUtilised,
                color: "#B6D4FF"
            },
            {
                name: "Total Approved",
                data: totalApproved,
                color: "transparent",
                showInLegend: false,
                enableMouseTracking: false,
                dataLabels: {
                    enabled: false   // ✅ turn off
                }
            }

        ],

        credits: {
            enabled: false
        }
    };

    const toIndian = (num) => {
        if (!num && num !== 0) return "0";
        return num.toLocaleString("en-IN");
    };
    const pieData = [
        {
            name: "Renovation / Upgradation",
            value: Number(data?.[0]?.approved_for_renovation_upgradation || 0),
            color: "#7EC8E3",
        },
        {
            name: "New Construction",
            value: Number(data?.[0]?.approved_for_new_construction || 0),
            color: "#76C893",
        },
        {
            name: "Equipment",
            value: Number(data?.[0]?.approved_for_equipment || 0),
            color: "#FFB347",
        },
        {
            name: "Soft Component",
            value: Number(data?.[0]?.approved_for_softcomponent || 0),
            color: "#D67BA8",
        },
    ]; const seriesData = pieData?.map(item => ({
        name: item.name,
        y: item.value,
        color: item.color
    }));

    const totalAmount = pieData?.reduce((sum, item) => sum + item.value, 0);
    const pieOptions = {
        chart: {
            type: "pie",
            height: 350
        },

        title: {
            text: null
        },

        subtitle: {
            text: `
            <div style="text-align:center">
                <span style="font-size:26px;font-weight:600">
                    ₹${toIndian(totalAmount)}
                </span><br/>
                <span style="font-size:13px;color:#777">
                    Total Amount
                </span>
            </div>
        `,
            align: "center",
            verticalAlign: "middle",
            useHTML: true
        },

        tooltip: {
            formatter: function () {
                /* eslint-disable react/no-this-in-sfc */

                return `<b>${this.point.name}</b><br/>₹${toIndian(this.y)}`; // NOSONAR - Highcharts formatter requires 'this' context
                /* eslint-enable react/no-this-in-sfc */

            }
        },

        plotOptions: {
            pie: {
                innerSize: "65%",   // 🔥 donut
                dataLabels: {
                    enabled: true,
                    distance: 15,
                    formatter: function () {
                        /* eslint-disable react/no-this-in-sfc */

                        return this.y > 0 ? toIndian(this.y) : null; // NOSONAR - Highcharts formatter requires 'this' context
                        /* eslint-enable react/no-this-in-sfc */


                    },
                    style: {
                        fontSize: "12px",
                        fontWeight: "500"
                    }
                }
            }
        },

        legend: {
            enabled: false   // ❗ we use custom legend on left
        },

        series: [
            {
                name: "Amount",
                data: seriesData
            }
        ],

        credits: {
            enabled: false
        }
    };



    const ReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,


        },
        {
            id: "name",
            header: "Institute Name",
            accessorKey: "name",
            Footer: "Total"


        },
        {
            id: "stateApproved",
            header: "State Approved (₹)",
            cell: ({ row }) => `₹${Number(row?.original?.stateApproved).toLocaleString("en-IN")}`,
            meta: { className: "text-start" },
            Footer: "stateApproved",
        },
        {
            id: "centralApproved",
            header: "Central Approved (₹)",
            cell: ({ row }) => `₹${Number(row?.original?.centralApproved).toLocaleString("en-IN")}`,
            meta: { className: "text-end" },
            Footer: "centralApproved",

        },
        {
            id: "totalApproved",
            header: "Total Approved (₹)",
            cell: ({ row }) => `₹${Number(row?.original?.totalApproved).toLocaleString("en-IN")}`,
            meta: { className: "text-end fw-bold" },
            Footer: "totalApproved",

        },
        {
            id: "stateUtilised",
            header: "State Utilised (₹)",
            cell: ({ row }) => `₹${Number(row?.original?.stateUtilised).toLocaleString("en-IN")}`,
            meta: { className: "text-end" },
            Footer: "stateUtilised",

        },
        {
            id: "centralUtilised",
            header: "Central Utilised (₹)",
            cell: ({ row }) => `₹${Number(row?.original?.centralUtilised).toLocaleString("en-IN")}`,
            meta: { className: "text-end" },
            Footer: "centralUtilised",

        },
        {
            id: "totalUtilised",
            header: "Total Utilised (₹)",
            cell: ({ row }) => `₹${Number(row?.original?.totalUtilised).toLocaleString("en-IN")}`,
            meta: { className: "text-end fw-bold" },
            Footer: "totalUtilised",

        },
    ];

    return (
        <>
            <FormikProvider value={AsmparlFormik}>

                <Form onChange={AsmparlFormik?.handleChange} onSubmit={AsmparlFormik?.handleSubmit} className='affl-form'>
                    <div className="graphical-bar-chart">
                        <bie.Row className="pt-4 mb-4">
                            <bie.Col lg={4}>
                                <label className="mb-1"> Assembly / Parliament:</label>
                                <Field as='select'
                                    className="form-control form-control-md"
                                    name="Asm_Parl"
                                    onChange={(e) => {
                                        GetAssemblyList(e.target.value); AsmparlFormik?.setFieldValue("apname", '');
                                        AsmparlFormik?.setFieldValue("clgname", '');
                                        setFinancaData([]);

                                    }}
                                >
                                    <option value="">---select---</option>
                                    <option value="A">Assembly</option>
                                    <option value="P">Parliament</option>
                                </Field>
                            </bie.Col>
                            <bie.Col lg={4}>
                                <label className="mb-1">Select {AsmparlFormik?.values?.Asm_Parl === "A" ? 'Assembly' : AsmparlFormik?.values?.Asm_Parl === "P" ? "Parliament" : ''} </label>
                                <Field as='select' name="apname"
                                    className="form-control form-control-md"
                                    //  onChange={(e) => { GetFinanceList(AsmparlFormik?.values?.Asm_Parl, e?.target?.value); setShow(false); }}
                                    onChange={(e) => {
                                        setFinancaData([]);
                                    }}
                                >
                                    <option value="">---select---</option>
                                    {assemblyList && assemblyList?.map((item) => (
                                        <option key={item.const_name} value={item.const_name}>
                                            {item?.const_name}
                                        </option>
                                    ))}
                                </Field>

                            </bie.Col>
                            <bie.Col lg={2}>
                                <button type="button" onClick={(e) => {
                                    GetFinanceList(AsmparlFormik?.values?.Asm_Parl, AsmparlFormik?.values?.apname);

                                }}
                                    className="btn btn-primary mt-4">Get Data</button>
                            </bie.Col>
                        </bie.Row>
                    </div>



                    {/* <bie.Row> */}
                    {dataset?.length > 0 ? (<>

                        {/* <bie.Col lg={12} md={12} xl={12} xxl={12} xs={12} sm={12} className='mb-4'>


                            <HighchartsReact
                                highcharts={Highcharts}
                                options={options}
                            />

                        </bie.Col> */}
                        <div className="oeveral-statcardnew p-4">

                            <HighchartsReact
                                highcharts={Highcharts}
                                options={options}
                            />

                            <bie.Col lg={12} md={12} xl={12} xxl={12} xs={12} sm={12} className='mb-4'>
                                {dataset?.length > 0 && (
                                    <>
                                        <div className='overal-stathead'>
                                            <span>Financial Details of {AsmparlFormik?.values?.apname} {AsmparlFormik?.values?.Asm_Parl === "A" ? 'Assembly' : AsmparlFormik?.values?.Asm_Parl === "P" ? "Parliament" : ''}</span>
                                        </div>
                                        <div className="all-table-content table-responsive">
                                            <CommonReactTable
                                                data={dataset}
                                                columns={ReportColumns}
                                                filename="Financial Details  Report"
                                                headerName="Financial Details  Report"
                                                showFooter="true"
                                                showPagination={false}
                                            />
                                        </div>
                                    </>
                                )}
                            </bie.Col>
                        </div>
                    </>) : erromsg === false && (
                        <center className="text-danger mt-4 h5">
                            ***** No Data Found *****
                        </center>
                    )}

                    {/* </bie.Row> */}


                    <br />

                    {pieData?.some(item => item.value > 0) && (


                        <div className="oeveral-statcardnew p-3 pt-5">
                            <div className="overal-stathead">
                                <span>{AsmparlFormik?.values?.apname} Component Details</span>
                            </div>

                            <bie.Row>
                                {/* LEFT – Custom Legend */}
                                <bie.Col xs={12} sm={12} md={12} lg={5} xl={4} xxl={3}>
                                    {pieData?.map((item, idx) => (
                                        <div
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "10px",
                                                gap: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    borderRadius: "4px",
                                                    backgroundColor: item.color,
                                                }}
                                            />
                                            <span style={{ fontWeight: 500 }}>{item.name}:</span>
                                            <span>{toIndian(item.value)}</span>
                                        </div>
                                    ))}
                                </bie.Col>

                                {/* RIGHT – Highcharts Donut */}
                                <bie.Col xs={12} sm={12} md={12} lg={7} xl={7} xxl={7}>
                                    <div style={{ width: "100%", height: 350 }}>
                                        <HighchartsReact
                                            highcharts={Highcharts}
                                            options={pieOptions}
                                        />
                                    </div>
                                </bie.Col>
                            </bie.Row>
                        </div>


                    )}


                </Form>

            </FormikProvider >


        </>)
}
